import { map } from "lodash";

import { getRandomColor } from "../helpers/generel.helpers";
import { Playlist } from "../types/playlist.types";
import { Song } from "../types/song.types";
import { BASE_URL } from "../axios";

export const getFormattedSong = (song: Song) => {
  return {
    ...song,
    url: `${BASE_URL}/songs/${song.fileName}`,
    color: getRandomColor(),
  };
};

export const getFormattedSongs = (songs: Song[]) =>
  map(songs, (item) => getFormattedSong(item));

export const getFormattedPlaylist = (playlist: Playlist) => {
  return {
    ...playlist,
    color: getRandomColor(),
  };
};

export const getFormattedPlaylists = (playlists: Playlist[]) => {
  return map(playlists, (playlist) => {
    return getFormattedPlaylist(playlist);
  });
};
